import { Button, Space } from '@sravni/react-design-system';
import { useBoolean, useIsMobile } from '@sravni/react-utils';

import type { TOnClickFlow } from 'commonTypes/api/scenarios/BaseTypes';

import { openExternalUrl, useAppSelector } from 'shared/lib';

import { selectIsLoading } from 'entities/scenario';

import { selectBankAccountOpened } from 'features/BankAccountOpened/model/bankAccountOpened.selector';
import { SmsCodeIssueInfoModal } from 'features/BankAccountOpened/ui/SmsCodeIssueInfoModal/ui';

export const BankAccountOpenedButtons = () => {
  const { buttons } = useAppSelector(selectBankAccountOpened);
  const [isVisible, setIsVisible] = useBoolean(false);
  const isMobile = useIsMobile();
  const isLoading = useAppSelector(selectIsLoading);

  const handleClick = (click: TOnClickFlow | string) => {
    if (typeof click === 'string') {
      setIsVisible.on();
      return;
    }

    if (click.action?.redirectUrl) {
      openExternalUrl(click.action.redirectUrl);
    }
  };

  return (
    <Space
      direction={isMobile ? 'vertical' : 'horizontal'}
      justify="space-between"
      size={isMobile ? 8 : 16}
    >
      {buttons?.map((button) => (
        <Button
          loading={isLoading}
          size={52}
          block
          variant={button.type}
          key={button.title}
          onClick={() => handleClick(button.onClick)}
        >
          {button.title}
        </Button>
      ))}

      <SmsCodeIssueInfoModal
        visible={isVisible}
        onClose={setIsVisible.off}
      />
    </Space>
  );
};
